<template>
  <div class="videos-block" :style="{backgroundColor: bgcolor}">
    <h2>{{title}}</h2>
    <h3>{{subTitle}}</h3>
    <ul class="videos">
      <li v-for="(item,i) in videos" :key="i">
        <div class="video-place">
          <img :src="item.img" alt="点击查看" @click="goVideo(item.link)" :title="item.title">
        </div>
        <h4>{{item.desc}}</h4>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    bgcolor: {
      type: String,
      default: '#ffffff'
    },
    title: {
      type: String,
      default: '工程应用'
    },
    subTitle: {
      type: String,
      default: 'Engineering Application'
    },
    videos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  methods: {
    goVideo (url) {
      window.open(url)
    }
  }
}
</script>
<style lang="less" scoped>
.videos-block {
  text-align: center;
  padding: 40px;
  overflow: auto;
  max-height: 790px;//正常两行，没有垂直滚动条
  font-family: "Microsoft YaHei";
  h2 {
    font-size: 30px;
    font-weight: 600;
    line-height: 42px;
    margin-bottom: 4px;
    margin-top: 8px;
  }
  h3 {
    font-size: 19px;
    line-height: 26px;
    margin-bottom: 28px;
  }
  h4 {
    font-size: 16px;
    font-weight: 550;
    color: #000;
    line-height: 20px;
    margin-top: 8px;
    }
  .videos {
    display: grid;
    grid-template-columns: repeat(3, 30%);
    grid-gap: 30px 40px;//行距 列距
    place-items: center center;
    justify-content: center;
    li {
      width: 100%;
    }
  }
  .video-place {
    // width: 239px;
    // height: 180px;
    // background: linear-gradient(
    //   135deg,
    //   rgba(112, 205, 251, 1) 0%,
    //   rgba(97, 121, 240, 1) 48%,
    //   rgba(114, 75, 223, 1) 100%
    // );
    // border-radius: 4px;
    img {
      border-radius: 4px;
      width:100%;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 990px) {
  .videos-block .videos {
    display: flex;
    flex-direction: column;
    li {
      margin-bottom: 15px;
    }
  }
}
</style>

